module.exports = __webpack_public_path__ + "img/26.d255c62a.png";